import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchInpatientStayByPet } from "../enums/queryFunction/Fetch";
import { GET_INPATIENT_STAY, SINGLE_ARCHIVE_KEY } from "../enums/QueryKeys";
import { GET_SINGLE_ARCHIVE, GET_INPATIENT_STAY as INPATIENT_STAY_API } from "../enums/ApiPaths";
import useCheckPath from "./useCheckPath";

export function useGetPetInpatientStay(petId) {
  const isArchive = useCheckPath();
  const { id: inpatientStayId } = useParams();

  const url = isArchive
    ? `${GET_SINGLE_ARCHIVE}${inpatientStayId}`
    : `${INPATIENT_STAY_API}${petId}`;

  const queryKey = isArchive
    ? `${SINGLE_ARCHIVE_KEY}${inpatientStayId}`
    : `${GET_INPATIENT_STAY}${petId}`;

  const enabled = isArchive ? !!inpatientStayId : !!petId;

  return useQuery({
    queryKey: [queryKey],
    queryFn: () => fetchInpatientStayByPet(url),
    enabled,
  });
}